import React from 'react';
import { AlertCircle, Clock, DollarSign, MessageCircle } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
import { CTAButton } from './shared/CTAButton';
export function PainPoints() {
  return <SectionWrapper bg="blush" data-id="element-140">
      <div className="max-w-3xl mx-auto" data-id="element-141">
        <p className="text-lg md:text-xl text-warm-dark leading-relaxed mb-8 font-medium" data-id="element-142">
          Si ya trabajás de manicurista, sabés algo que las principiantes
          todavía no entienden:
          <br data-id="element-143" />
          <br data-id="element-144" />
          No se trata de hacer uñas.
          <br data-id="element-145" />
          <span className="font-bold text-rose text-2xl font-serif block mt-2" data-id="element-146">
            Se trata de que tus sets se vean consistentes.
          </span>
        </p>

        <p className="text-warm-muted mb-6" data-id="element-147">
          Porque cuando te falta consistencia, pasa esto:
        </p>

        <ul className="space-y-4 mb-10" data-id="element-148">
          {["Un set te sale precioso… y el siguiente 'más o menos'", 'La cutícula te queda prolija… pero no siempre', 'La estructura no se ve igual desde todos los ángulos', 'Aparecen levantamientos y te comen la agenda con retoques', 'Tardás demasiado, te agotás, y al final sentís que estás cobrando poco para lo que trabajás'].map((point, i) => <li key={i} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border border-cream" data-id="element-149">
              <AlertCircle className="w-6 h-6 text-rose shrink-0 mt-0.5" data-id="element-150" />
              <span className="text-warm-dark font-medium" data-id="element-151">{point}</span>
            </li>)}
        </ul>

        <p className="text-lg text-warm-dark mb-8" data-id="element-152">
          Y ahí aparece el bloqueo:
          <br data-id="element-153" />
          querés subir precios, querés posicionarte mejor, querés que tus fotos
          se vean "nivel estudio"…
          <br data-id="element-154" />
          <strong className="text-rose font-bold mt-2 block" data-id="element-155">
            pero te falta un método técnico que puedas repetir set tras set.
          </strong>
        </p>

        <div className="text-center mb-16" data-id="element-156">
          <CTAButton variant="secondary" scrollTo="comprar" data-id="element-157">
            SÍ, QUIERO MEJORAR MI TERMINACIÓN
          </CTAButton>
        </div>

        <div className="mt-16" data-id="element-158">
          <h2 className="text-3xl font-serif font-bold text-center text-warm-dark mb-10" data-id="element-159">
            El costo oculto de seguir "a prueba y error"
          </h2>

          <p className="text-center text-warm-muted mb-8" data-id="element-160">
            Cuando tu técnica no está ordenada, lo pagás en 3 monedas:
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-161">
            <div className="bg-white p-6 rounded-2xl shadow-soft border border-cream flex flex-col items-center text-center" data-id="element-162">
              <div className="w-12 h-12 bg-blush rounded-full flex items-center justify-center mb-4" data-id="element-163">
                <Clock className="w-6 h-6 text-rose" data-id="element-164" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-warm-dark" data-id="element-165">
                1) Tiempo
              </h3>
              <p className="text-warm-muted text-sm" data-id="element-166">
                Se te alargan los turnos, no sabés cuánto vas a tardar y
                terminás corriendo.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-soft border border-cream flex flex-col items-center text-center" data-id="element-167">
              <div className="w-12 h-12 bg-blush rounded-full flex items-center justify-center mb-4" data-id="element-168">
                <DollarSign className="w-6 h-6 text-rose" data-id="element-169" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-warm-dark" data-id="element-170">
                2) Plata
              </h3>
              <p className="text-warm-muted text-sm" data-id="element-171">
                Si tardás más, ganás menos por hora (aunque tu lista de precios
                diga otra cosa).
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-soft border border-cream flex flex-col items-center text-center" data-id="element-172">
              <div className="w-12 h-12 bg-blush rounded-full flex items-center justify-center mb-4" data-id="element-173">
                <MessageCircle className="w-6 h-6 text-rose" data-id="element-174" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-warm-dark" data-id="element-175">
                3) Reputación
              </h3>
              <p className="text-warm-muted text-sm" data-id="element-176">
                Cuando algo se levanta antes de tiempo, no solo molesta…{' '}
                <strong className="text-rose" data-id="element-177">se comenta</strong>.
              </p>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl border-l-4 border-rose shadow-sm" data-id="element-178">
            <p className="text-warm-dark font-medium mb-4" data-id="element-179">
              Lo peor no es el error. Lo peor es el retrabajo, la inseguridad
              constante y seguir cobrando lo mismo.
            </p>
            <p className="text-warm-muted" data-id="element-180">
              Y no, esto no se arregla mirando tutoriales sueltos. Los
              tutoriales te dan "ideas". Pero no te dan{' '}
              <strong data-id="element-181">criterio</strong>. No te dan{' '}
              <strong data-id="element-182">procedimiento</strong>. No te dan{' '}
              <strong data-id="element-183">estándar</strong>.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}